/* eslint-disable camelcase */
export default {
	please_select: 'Please select',
	Enter_a_keyword: 'Enter a keyword',
	to: 'to',
	start_date: 'start date',
	end_date: 'end date',
	Procurement_BU: 'Procurement BU',
	Order: 'Order',
	order_line: 'Order Line',
	Supplier: 'Supplier',
	purchase_type: 'Purchase Type',
	requested_delivery_date: 'Requested Delivery Date',
	promised_delivery_date: 'Promised Delivery Date',
	Item: 'Item',
	item_description: 'Item Description',
	Location: 'Location',
	ordered_quantity: 'Ordered Quantity',
	received_quantity: 'Received Quantity',
	available_quantity: 'Available Quantity',
	no_data_available: 'No data available',
	Search: 'Search',
	search_results: 'Search Results',
	Receipt: 'Receipt',
	Status: 'Status',
	reject: '已退货',
	undone: '未完成',
	received: 'Received By',
	creation_date: 'Creation Date',
	shipped_date: 'Shipped Date',
	General: 'General',
	Lines: 'Lines',
	Line: 'Line',
	Ordered: 'Ordered',
	Returned: 'Returned',
	UOM: 'UOM',
	Quantity: 'Quantity',
	approval_history: 'Approval History',
	User: 'User',
	Post: 'Post',
	Setp: 'Setp',
	Option: 'Option',
	approved_date: 'Approved Date',
	consuming_time: 'Consuming Time',
	Select_a_date: 'Select a date',
	Received: 'Received',
	Save: 'Save',
	Submit: 'Submit',
	Cancel: 'Cancel',
	Validate: 'Validate',
	Delete: 'Delete',
	Duplicate: 'Duplicate',
	Done: 'Done',
	Acknowledge: 'Acknowledge',
	Agree: 'Agree',
	CreationDate: 'Creation Date',
	Reject: 'Reject',
	SerialNumber: 'Serial Number',
	returnOrderDetails: 'returnOrderDetails',
	close: '关闭',
	financial_information: '财务信息',
	total_acceptance_amount_including_reduction: '验收总金额（含折减金额）',
	add_line: '添加行',
	batch_delete: '批量删除',
	product_name: '品名',
	describe: '描述',
	unit_price: '单价',
	purchase_quantity: '采购数量',
	subtotal: '小计金额',
	frame_unit_price: '框架单价',
	reference_unit_price: '参考单价',
	last_purchase_price: '上次采购价',
	discount: '折扣',
	quantity_delivered_this_time: '本次交付数量',
	purchase_order_details: '订单采购明细',
	edit: '编辑',
	new_blank_line: '新增空白行',
	financial_total_amount: '财务总金额',
	material: '物料',
	purchase_description: '采购说明',
	purchase_amount: '采购金额',
	department: '所属部门',
	account_subject: '核算科目',
	project_auxiliary_section: '项目辅助段',
	is_capitalization: '是否资本化',
	tax_code: '税码',
	accepted_amount: '已验收金额',
	acceptable_amount: '可验收金额',
	amount_of_this_acceptance: '本次验收金额',

	// IEG-验收录入-订单执行信息新增
	order_execution_info: '订单执行信息',
	purchasing_category: '采购类别',
	resource_type: '资源类型',
	scenes: '场景',
	order_effect_amount: '订单效果金额',
	this_amount: '本次金额',
	performance_indicators_supplier: '效果指标(供应商)',
	performance_indicators_business: '效果指标(业务)',
	optional: '选填',
	required: '必填',
	order_performance_indicator: '订单效果指标',
	execute_start_time: '执行开始时间',

	// IEG-验收录入-供应商评估
	supplier_evaluation: '供应商评估',
	evaluation_item: '评估项',
	evaluation_score: '评估分数',
	weight: '权重',
	score_system: '分制',
	description_of_scoring_reference_standard: '打分参考标准说明',
	total_score: '总分',
	overall_evaluation: '总体评价',
	additional_discount_for_the_whole_order: '整单额外折减',
	overwrite_import: '覆盖导入'
};
